<template>
  <div class="wrapper-content wrapper">
    <modal-form modal-id="add-notifications">
      <div slot="title">Add Index Request</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-4">Type</div>
            <div class="col-lg-8">
              <select name="" id="" class="form-control" v-model="type">
                <option value="URL_DELETED">Delete</option>
                <option value="URL_UPDATED">Update</option>
              </select>
            </div>
            <div class="col-lg-4">Urls</div>
            <div class="col-lg-8">
              <textarea cols="30" rows="10" class="form-control" v-model="urls"></textarea>
            </div>
            <div class="col-lg-12 m-t-sm">
              <button class="btn btn-primary pull-right" @click="sendRequest">Send</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>Index Helper</h5>
        <button class="btn btn-primary btn-xs pull-right" data-toggle="modal" data-target="#add-notifications">Add Request</button>
      </div>
      <div class="ibox-content col-lg-12">
        <div v-if="quota.used !== false" class="m-l-sm m-b-sm"><strong>{{ quota.used }}</strong> of <strong>{{ quota.limit }}</strong> daily requests used <small>(reset at 8am UTC)</small></div>
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Time</th>
            <th>Url</th>
            <th>Type</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in notifications" :key="n.id">
            <td>
              <i class="fa fa-check" v-if="n.success" style="color: green"></i>
              <i class="fas fa-times" v-else style="color: red" :title="n.error"></i>
              {{ $moment(n.time.date).format('DD.MM. HH:mm') }}
            </td>
            <td>{{ n.url }}</td>
            <td>{{ n.type }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Form from '../../Helpers/Modal/Form'
import axios from 'axios'
export default {
  data () {
    return {
      type: 'URL_DELETED',
      urls: '',
      notifications: [],
      quota: {
        limit: 200,
        used: false,
        available: '/'
      }
    }
  },
  components: {
    modalForm: Form
  },
  mounted () {
    this.getNotifications()
  },
  methods: {
    getNotifications () {
      axios.get('/tools/google-index/notifications')
        .then(r => {
          this.notifications = r.data.data
          this.quota = r.data.meta.quota
        })
        .catch(e => {
          this.$toastr.error(e)
        })
    },
    sendRequest () {
      let payload = []

      this.urls.split('\n').forEach(url => {
        if (url.length > 5) {
          payload.push({
            url: url,
            type: this.type
          })
        }
      })

      if (payload.length < 1) {
        this.$toastr.error('Please provide some proper urls', 'Meh...')
        return
      }

      axios.post('/tools/google-index', payload)
        .then(r => {
          this.$toastr.success('Notifications sent!')
          $('#add-notifications').modal('hide')
          this.getNotifications()
          this.urls = ''
        })
        .catch(e => {
          this.$toastr.error(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Std/GoogleIndexHelper.vue